// extracted by mini-css-extract-plugin
export var colorSquare = "_nr-0";
export var danger = "_nr-5";
export var lightPink = "_nr-8";
export var neutralBlue = "_nr-7";
export var neutralYellow = "_nr-6";
export var normal = "_nr-1";
export var primary = "_nr-2";
export var primaryLight = "_nr-3";
export var solidBlack = "_nr-g";
export var solidGreen = "_nr-b";
export var solidLightBlue = "_nr-d";
export var solidNavy = "_nr-c";
export var solidOrange = "_nr-f";
export var solidPink = "_nr-e";
export var solidRed = "_nr-9";
export var solidYellow = "_nr-a";
export var success = "_nr-4";